import { resourceReservationIdZodSchema } from "@@/shared/acquire/resources/resource-reservation-id";
import { iconNameZodString } from "@@/shared/icon-name";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";
import { dateRangeZodObject } from "../../date-time/date-range";
import { timeRangeZodSchema } from "../../date-time/time-range";
import { orderGroupIdZodSchema } from "../../order-groups/order-group-id";
import { orderIdZodSchema } from "../../orders/order-id";
import { agendaResourceDataZodObject } from "./agenda-resource-data";

const agendaItem_ReservationDataZodObject = z.object({
    _type: z.literal("AGENDA_ITEM__RESERVATION_DATA"),
    orderId: orderIdZodSchema,
    orderGroupId: orderGroupIdZodSchema,
    reservationId: resourceReservationIdZodSchema,
    reservationDateRange: dateRangeZodObject,
    reservationTime: z.union([timeRangeZodSchema, dateRangeZodObject]),
    resource: agendaResourceDataZodObject,
    /** Total quantity, all quantity type quantities summed up */
    totalQuantity: z.number(),
    resourceQuantity: z.number(),
    /** Quantities divided by quantity type */
    quantities: z.array(
        z.object({
            key: z.string(),
            label: requiredTranslatableZodSchema,
            quantity: z.number(),
            iconName: iconNameZodString,
        }),
    ),
});

type AgendaItem_ReservationData = z.infer<
    typeof agendaItem_ReservationDataZodObject
>;

export { agendaItem_ReservationDataZodObject };
export type { AgendaItem_ReservationData };
